<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>汇总单详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;"
          :span="24"
        >
          基本信息
        </div>
        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="100"
            :data="resData.summary_info"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="wave_picking_summary_id"
              label="汇总单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="all_num"
              label="波次数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="check_num"
              label="已校验数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="创建人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
          :span="24"
        >
          <span>波次信息</span>
        </div>
        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.wave_picking.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="user_id"
              label="用户id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_company"
              label="快递公司"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_num"
              label="快递单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_print_status"
              label="面单状态"
            ></el-table-column>
            <el-table-column
              v-if="type != 4"
              align="center"
              prop="order_sn"
              label="订单号"
            ></el-table-column>
            <el-table-column
              v-if="type == 4"
              align="center"
              prop="work_id"
              label="工单id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="custom_note"
              label="用户备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_note"
              label="客服备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="生成时间"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right;padding: 25px;">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper,sizes"
            :total="resData.wave_picking.total"
            :page-size="form.pagesize"
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        pagesize: 20,
        delNum: 0,
        wave_picking_info_id: 0,
        wave_picking_summary_id: this.$route.params.id,
      },
      msg: "",
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/WavePickingSummaryInfo",
      curPage: 1,
      detailcurPage: 1,
      filterFold: false,
      isAll: false,
      wave_picking_summary_id: this.$route.params.id,
      infoDetail_pages: 0,
      infoDetail: [],
      dialogFormVisible: false,
      type: 1,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    openDetail(row) {
      //跳到波次详情
      if (this.type == 4) {
        this.$router.push(
          `/home/aswavepicking/aswavepickinginfo/${row.wave_picking_id}`,
        );
      } else {
        this.$router.push(
          `/home/wavepicking/wavepickinginfo/${row.wave_picking_id}`,
        );
      }
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.$route.query.type) {
        this.type = parseFloat(this.$route.query.type);
      }
      if (this.type == 4) {
        this.url = "/erp/asWavePicking/WavePickingSummaryInfo";
      } else {
        this.url = "/erp/WavePicking/WavePickingSummaryInfo";
      }
      this.$http
        .post(
          this.url + "/wave_picking_summary_id/" + this.wave_picking_summary_id,
          this.filteredForm,
        )
        .then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      let multipleSelection = [];
      for (let key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.fetchData(true);
    },
    // 切换页码
    handleCurrentChange2(val) {
      this.form.page = val;
      // this.tableLoading = true;
      this.$http
        .get(
          "/erp/wavePickingInfo/detail/wave_picking_info_id/" +
            this.wave_picking_info_id +
            "/page/" +
            val,
        )
        .then(res => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.infoDetail = res.data.data;
          }
        });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      var result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WavePickingSumaryInfo.vue